import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { tiposMaquinaService } from '../../services';
import { TipoMaquina } from '../../types/producao';

const columns: ResourceColumn<TipoMaquina>[] = [
  { header: 'Código', accessor: 'codigo' },
  { header: 'Descrição', accessor: 'descricao' },
];

export const TiposMaquinaListPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ResourceListPage
      title="Tipos de máquina"
      description="Catálogo de tipos de máquina."
      columns={columns}
      service={tiposMaquinaService}
      createPath="/admin/producao/tipos-maquina/novo"
      onEdit={(item) =>
        (item as { id?: number }).id &&
        navigate('/admin/producao/tipos-maquina/editar', { state: { record: item } })
      }
      onDelete={(item) =>
        (item as { id?: number }).id ? tiposMaquinaService.remove((item as any).id) : Promise.resolve()
      }
    />
  );
};
